// // FreeExtensionModal.js
// // Drop in: src/Components/FreeExtensionModal.js

// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { message, Spin, Upload } from "antd";
// import { UploadOutlined, CheckCircleFilled, ClockCircleOutlined } from "@ant-design/icons";
// import axios from "axios";
// import { BASE_URL } from "../Config";

// // ── Constants ─────────────────────────────────────────────────────────────────

// const PLAN_META = {
//   "basic-1": {
//     label: "Basic - 1",
//     color: "#10b981",
//     bg: "#ecfdf5",
//     border: "#6ee7b7",
//     instruction: "Share yogarefer.com on 1 social media platform",
//     platformsRequired: 1,
//     needsBlog: false,
//     needsGroups: false,
//   },
//   "basic-2": {
//     label: "Basic - 2",
//     color: "#3b82f6",
//     bg: "#eff6ff",
//     border: "#93c5fd",
//     instruction: "Share yogarefer.com on 3 social media platforms",
//     platformsRequired: 3,
//     needsBlog: false,
//     needsGroups: false,
//   },
//   standard: {
//     label: "Standard",
//     color: "#8b5cf6",
//     bg: "#f5f3ff",
//     border: "#c4b5fd",
//     instruction: "Share yogarefer.com on 6 social media platforms",
//     platformsRequired: 6,
//     needsBlog: false,
//     needsGroups: false,
//   },
//   premium: {
//     label: "Premium",
//     color: "#f59e0b",
//     bg: "#fffbeb",
//     border: "#fcd34d",
//     instruction: "Write a blog/review + share on 6 platforms + share in yoga groups",
//     platformsRequired: 6,
//     needsBlog: true,
//     needsGroups: true,
//   },
// };

// const ALL_PLATFORMS = [
//   "Instagram",
//   "Facebook",
//   "Twitter / X",
//   "WhatsApp",
//   "Telegram",
//   "YouTube",
//   "Pinterest",
//   "LinkedIn",
//   "TikTok",
//   "Other",
// ];

// // ── Component ─────────────────────────────────────────────────────────────────

// const FreeExtensionModal = ({ open, onClose, onSuccess }) => {
//   const [step, setStep] = useState(1); // 1 = choose plan, 2 = details + proof
//   const [plansInfo, setPlansInfo] = useState(null);
//   const [loadingPlans, setLoadingPlans] = useState(false);

//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [withLogo, setWithLogo] = useState(false);

//   const [selectedPlatforms, setSelectedPlatforms] = useState([]);
//   const [blogUrl, setBlogUrl] = useState("");
//   const [yogaGroups, setYogaGroups] = useState("");
//   const [proofFiles, setProofFiles] = useState([]);

//   const [submitting, setSubmitting] = useState(false);

//   // Fetch plans info when modal opens
//   useEffect(() => {
//     if (!open) return;
//     setStep(1);
//     setSelectedPlan(null);
//     setWithLogo(false);
//     setSelectedPlatforms([]);
//     setBlogUrl("");
//     setYogaGroups("");
//     setProofFiles([]);

//     const fetchPlans = async () => {
//       setLoadingPlans(true);
//       try {
//         const token = sessionStorage.getItem("token");
//         const { data } = await axios.get(`${BASE_URL}/free-extension/plans-info`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setPlansInfo(data.data);
//       } catch {
//         message.error("Failed to load plan info.");
//       } finally {
//         setLoadingPlans(false);
//       }
//     };
//     fetchPlans();
//   }, [open]);

//   // ── Helpers ──────────────────────────────────────────────────────────────────

//   const planMeta = selectedPlan ? PLAN_META[selectedPlan] : null;
//   const planData = plansInfo?.plans?.find((p) => p.plan === selectedPlan);

//   const togglePlatform = (platform) => {
//     setSelectedPlatforms((prev) =>
//       prev.includes(platform) ? prev.filter((p) => p !== platform) : [...prev, platform]
//     );
//   };

//   const canProceedStep1 = !!selectedPlan;

//   const canSubmit = () => {
//     if (!selectedPlan || !planMeta) return false;
//     if (selectedPlatforms.length < planMeta.platformsRequired) return false;
//     if (planMeta.needsBlog && !blogUrl.trim()) return false;
//     if (planMeta.needsGroups && !yogaGroups.trim()) return false;
//     if (proofFiles.length === 0) return false;
//     return true;
//   };

//   // ── Submit ───────────────────────────────────────────────────────────────────

//   const handleSubmit = async () => {
//     if (!canSubmit()) return;
//     setSubmitting(true);
//     try {
//       const token = sessionStorage.getItem("token");
//       const formData = new FormData();
//       formData.append("plan", selectedPlan);
//       formData.append("withLogo", String(withLogo));
//       formData.append("platforms", JSON.stringify(selectedPlatforms));
//       if (blogUrl) formData.append("blogUrl", blogUrl);
//       if (yogaGroups) {
//         formData.append(
//           "yogaGroups",
//           JSON.stringify(yogaGroups.split("\n").map((g) => g.trim()).filter(Boolean))
//         );
//       }
//       proofFiles.forEach((f) => formData.append("proofImages", f.originFileObj));

//       const { data } = await axios.post(`${BASE_URL}/free-extension/submit`, formData, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       message.success(
//         `Request submitted! You'll receive ${data.data.extensionDays} days on approval.`
//       );
//       onSuccess?.();
//       onClose();
//     } catch (err) {
//       message.error(err.response?.data?.error ?? "Submission failed. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // ── Render ───────────────────────────────────────────────────────────────────

//   if (!open) return null;

//   return (
//     <AnimatePresence>
//       {open && (
//         <>
//           {/* Backdrop */}
//           <motion.div
//             onClick={onClose}
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             style={{
//               position: "fixed", inset: 0,
//               background: "rgba(0,0,0,0.45)",
//               zIndex: 1000,
//             }}
//           />

//           {/* Modal */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.88, y: 24 }}
//             animate={{ opacity: 1, scale: 1, y: 0 }}
//             exit={{ opacity: 0, scale: 0.88, y: 24 }}
//             transition={{ duration: 0.22, ease: "easeOut" }}
//             style={{
//               position: "fixed",
//               top: "10px", left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 1001,
//               width: "min(95vw, 580px)",
//               maxHeight: "95vh",
//               overflowY: "auto",
//               background: "#fff",
//               borderRadius: 20,
//               boxShadow: "0 24px 80px rgba(0,0,0,0.18)",
//               padding: "28px 28px 24px",
//             }}
//           >
//             {/* Header */}
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
//               <div>
//                 <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: "#1a1a2e" }}>
//                   🎁 Free Extension
//                 </h2>
//                 <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6b7280" }}>
//                   Share yogarefer.com and get a free extension
//                 </p>
//               </div>
//               <button
//                 onClick={onClose}
//                 style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#6b7280" }}
//               >
//                 ×
//               </button>
//             </div>

//             {/* Step indicator */}
//             <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
//               {["Choose Plan", "Submit Proof"].map((label, i) => (
//                 <div
//                   key={i}
//                   style={{
//                     flex: 1, textAlign: "center", padding: "6px 0",
//                     borderRadius: 8, fontSize: 12, fontWeight: 600,
//                     background: step === i + 1 ? "#4f46e5" : "#f3f4f6",
//                     color: step === i + 1 ? "#fff" : "#9ca3af",
//                   }}
//                 >
//                   {i + 1}. {label}
//                 </div>
//               ))}
//             </div>

//             {/* ── STEP 1: Choose Plan ── */}
//             {step === 1 && (
//               <>
//                 {loadingPlans ? (
//                   <div style={{ textAlign: "center", padding: "40px 0" }}>
//                     <Spin size="large" />
//                   </div>
//                 ) : (
//                   <>
//                     {/* Tier info */}
//                     {plansInfo && (
//                       <div style={{
//                         background: "#f0f9ff", border: "1px solid #bae6fd",
//                         borderRadius: 10, padding: "10px 14px", marginBottom: 16,
//                         fontSize: 13, color: "#0369a1",
//                       }}>
//                         📊 You have <strong>{plansInfo.approvedCount}</strong> approved image(s) →
//                         Tier <strong>{plansInfo.tier.toUpperCase()}</strong>
//                       </div>
//                     )}

//                     {/* Logo toggle */}
//                     <div style={{
//                       display: "flex", alignItems: "center", gap: 10,
//                       background: "#faf5ff", border: "1px solid #e9d5ff",
//                       borderRadius: 10, padding: "10px 14px", marginBottom: 18,
//                     }}>
//                       <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13 }}>
//                         <input
//                           type="checkbox"
//                           checked={withLogo}
//                           onChange={(e) => setWithLogo(e.target.checked)}
//                           style={{ width: 16, height: 16 }}
//                         />
//                         <span style={{ fontWeight: 600, color: "#7c3aed" }}>Include logo watermark</span>
//                       </label>
//                       <span style={{ fontSize: 11, color: "#9ca3af" }}>
//                         (fewer days, but your logo shown on images)
//                       </span>
//                     </div>

//                     {/* Plan cards */}
//                     <div style={{ display: "grid", gap: 12 }}>
//                       {(plansInfo?.plans ?? []).map((p) => {
//                         const meta = PLAN_META[p.plan];
//                         const days = withLogo ? p.withLogoDays : p.mediaOnlyDays;
//                         const isSelected = selectedPlan === p.plan;
//                         return (
//                           <div
//                             key={p.plan}
//                             onClick={() => setSelectedPlan(p.plan)}
//                             style={{
//                               border: `2px solid ${isSelected ? meta.color : meta.border}`,
//                               borderRadius: 12,
//                               padding: "14px 16px",
//                               cursor: "pointer",
//                               background: isSelected ? meta.bg : "#fff",
//                               transition: "all 0.15s",
//                               display: "flex",
//                               justifyContent: "space-between",
//                               alignItems: "center",
//                             }}
//                           >
//                             <div>
//                               <div style={{ fontWeight: 700, fontSize: 15, color: meta.color }}>
//                                 {isSelected && <CheckCircleFilled style={{ marginRight: 6 }} />}
//                                 {meta.label}
//                               </div>
//                               <div style={{ fontSize: 12, color: "#6b7280", marginTop: 3 }}>
//                                 {meta.instruction}
//                               </div>
//                             </div>
//                             <div style={{ textAlign: "right", minWidth: 80 }}>
//                               <div style={{ fontSize: 22, fontWeight: 800, color: meta.color }}>
//                                 +{days}d
//                               </div>
//                               <div style={{ fontSize: 10, color: "#9ca3af" }}>
//                                 {withLogo ? "with logo" : "media only"}
//                               </div>
//                               {/* Show the other option dimmed */}
//                               <div style={{ fontSize: 10, color: "#d1d5db" }}>
//                                 / {withLogo ? p.mediaOnlyDays : p.withLogoDays}d {withLogo ? "no logo" : "with logo"}
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>

//                     <button
//                       disabled={!canProceedStep1}
//                       onClick={() => setStep(2)}
//                       style={{
//                         marginTop: 20, width: "100%", padding: "13px 0",
//                         borderRadius: 12, border: "none", cursor: canProceedStep1 ? "pointer" : "not-allowed",
//                         background: canProceedStep1 ? "#4f46e5" : "#e5e7eb",
//                         color: canProceedStep1 ? "#fff" : "#9ca3af",
//                         fontWeight: 700, fontSize: 15,
//                       }}
//                     >
//                       Continue →
//                     </button>
//                   </>
//                 )}
//               </>
//             )}

//             {/* ── STEP 2: Submit Proof ── */}
//             {step === 2 && planMeta && (
//               <>
//                 {/* Selected plan summary */}
//                 <div style={{
//                   background: planMeta.bg, border: `1px solid ${planMeta.border}`,
//                   borderRadius: 10, padding: "10px 14px", marginBottom: 18,
//                   display: "flex", justifyContent: "space-between",
//                 }}>
//                   <div>
//                     <div style={{ fontWeight: 700, color: planMeta.color }}>{planMeta.label}</div>
//                     <div style={{ fontSize: 12, color: "#6b7280" }}>{planMeta.instruction}</div>
//                   </div>
//                   <div style={{ textAlign: "right" }}>
//                     <div style={{ fontWeight: 800, fontSize: 18, color: planMeta.color }}>
//                       +{withLogo ? planData?.withLogoDays : planData?.mediaOnlyDays}d
//                     </div>
//                     <button
//                       onClick={() => setStep(1)}
//                       style={{ background: "none", border: "none", color: "#6b7280", fontSize: 11, cursor: "pointer" }}
//                     >
//                       Change
//                     </button>
//                   </div>
//                 </div>

//                 {/* Platform selection */}
//                 <div style={{ marginBottom: 18 }}>
//                   <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8, color: "#374151" }}>
//                     ✅ Select platforms you shared on
//                     <span style={{ fontWeight: 400, color: "#9ca3af", marginLeft: 4 }}>
//                       (need {planMeta.platformsRequired}, selected {selectedPlatforms.length})
//                     </span>
//                   </div>
//                   <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
//                     {ALL_PLATFORMS.map((platform) => {
//                       const selected = selectedPlatforms.includes(platform);
//                       return (
//                         <button
//                           key={platform}
//                           onClick={() => togglePlatform(platform)}
//                           style={{
//                             padding: "6px 12px", borderRadius: 20, fontSize: 12,
//                             border: `1.5px solid ${selected ? planMeta.color : "#d1d5db"}`,
//                             background: selected ? planMeta.bg : "#fff",
//                             color: selected ? planMeta.color : "#374151",
//                             cursor: "pointer", fontWeight: selected ? 700 : 400,
//                           }}
//                         >
//                           {selected && "✓ "}{platform}
//                         </button>
//                       );
//                     })}
//                   </div>
//                 </div>

//                 {/* Premium extras */}
//                 {planMeta.needsBlog && (
//                   <div style={{ marginBottom: 14 }}>
//                     <label style={{ display: "block", fontWeight: 600, fontSize: 13, marginBottom: 6, color: "#374151" }}>
//                       📝 Blog / Review URL <span style={{ color: "#ef4444" }}>*</span>
//                     </label>
//                     <input
//                       type="url"
//                       placeholder="https://yourblog.com/yogarefer-review"
//                       value={blogUrl}
//                       onChange={(e) => setBlogUrl(e.target.value)}
//                       style={{
//                         width: "100%", padding: "10px 12px", borderRadius: 8,
//                         border: "1.5px solid #d1d5db", fontSize: 13, boxSizing: "border-box",
//                         outline: "none",
//                       }}
//                     />
//                   </div>
//                 )}

//                 {planMeta.needsGroups && (
//                   <div style={{ marginBottom: 14 }}>
//                     <label style={{ display: "block", fontWeight: 600, fontSize: 13, marginBottom: 6, color: "#374151" }}>
//                       🧘 Yoga Groups (one per line) <span style={{ color: "#ef4444" }}>*</span>
//                     </label>
//                     <textarea
//                       placeholder="Yoga lovers - Facebook Group&#10;Daily Yoga - Telegram&#10;..."
//                       value={yogaGroups}
//                       onChange={(e) => setYogaGroups(e.target.value)}
//                       rows={3}
//                       style={{
//                         width: "100%", padding: "10px 12px", borderRadius: 8,
//                         border: "1.5px solid #d1d5db", fontSize: 13,
//                         boxSizing: "border-box", resize: "vertical", outline: "none",
//                       }}
//                     />
//                   </div>
//                 )}

//                 {/* Proof screenshot upload */}
//                 <div style={{ marginBottom: 20 }}>
//                   <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8, color: "#374151" }}>
//                     📸 Upload Proof Screenshots <span style={{ color: "#ef4444" }}>*</span>
//                   </div>
//                   <Upload
//                     listType="picture-card"
//                     fileList={proofFiles}
//                     onChange={({ fileList }) => setProofFiles(fileList)}
//                     beforeUpload={() => false} // prevent auto-upload
//                     accept="image/*"
//                     multiple
//                     maxCount={10}
//                   >
//                     {proofFiles.length < 10 && (
//                       <div>
//                         <UploadOutlined />
//                         <div style={{ fontSize: 12, marginTop: 4 }}>Upload</div>
//                       </div>
//                     )}
//                   </Upload>
//                   <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
//                     Must include #YogaRefer and @yogarefer in your posts. Max 10 screenshots.
//                   </div>
//                 </div>

//                 {/* Reminder */}
//                 <div style={{
//                   background: "#fffbeb", border: "1px solid #fcd34d",
//                   borderRadius: 8, padding: "10px 12px", marginBottom: 18, fontSize: 12, color: "#92400e",
//                 }}>
//                   <ClockCircleOutlined style={{ marginRight: 6 }} />
//                   Share must be <strong>public</strong>, include <strong>#YogaRefer</strong> and{" "}
//                   <strong>#YogaWith[YourName]</strong>, within <strong>48 hours</strong> of submission.
//                 </div>

//                 {/* Action buttons */}
//                 <div style={{ display: "flex", gap: 10 }}>
//                   <button
//                     onClick={() => setStep(1)}
//                     style={{
//                       flex: 1, padding: "12px 0", borderRadius: 12,
//                       border: "1.5px solid #d1d5db", background: "#fff",
//                       cursor: "pointer", fontWeight: 600, fontSize: 14, color: "#374151",
//                     }}
//                   >
//                     ← Back
//                   </button>
//                   <button
//                     disabled={!canSubmit() || submitting}
//                     onClick={handleSubmit}
//                     style={{
//                       flex: 2, padding: "12px 0", borderRadius: 12, border: "none",
//                       cursor: canSubmit() && !submitting ? "pointer" : "not-allowed",
//                       background: canSubmit() && !submitting ? "#4f46e5" : "#e5e7eb",
//                       color: canSubmit() && !submitting ? "#fff" : "#9ca3af",
//                       fontWeight: 700, fontSize: 15,
//                     }}
//                   >
//                     {submitting ? <Spin size="small" /> : "Submit Request 🚀"}
//                   </button>
//                 </div>
//               </>
//             )}
//           </motion.div>
//         </>
//       )}
//     </AnimatePresence>
//   );
// };

// export default FreeExtensionModal;

// FreeExtensionModal.js
// Drop in: src/Components/FreeExtensionModal.js

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { message, Spin, Upload } from "antd";
import {
  UploadOutlined,
  CheckCircleFilled,
  ClockCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../Config";

// ── Constants ─────────────────────────────────────────────────────────────────

const PLAN_META = {
  "basic-1": {
    label: "Basic - 1",
    color: "#10b981",
    bg: "#ecfdf5",
    border: "#6ee7b7",
    instruction: "Share yogarefer.com on 1 social media platform",
    platformsRequired: 1,
    needsBlog: false,
    needsGroups: false,
  },
  "basic-2": {
    label: "Basic - 2",
    color: "#3b82f6",
    bg: "#eff6ff",
    border: "#93c5fd",
    instruction: "Share yogarefer.com on 3 social media platforms",
    platformsRequired: 3,
    needsBlog: false,
    needsGroups: false,
  },
  standard: {
    label: "Standard",
    color: "#8b5cf6",
    bg: "#f5f3ff",
    border: "#c4b5fd",
    instruction: "Share yogarefer.com on 6 social media platforms",
    platformsRequired: 6,
    needsBlog: false,
    needsGroups: false,
  },
  premium: {
    label: "Premium",
    color: "#f59e0b",
    bg: "#fffbeb",
    border: "#fcd34d",
    instruction:
      "Write a blog/review + share on 6 platforms + share in yoga groups",
    platformsRequired: 6,
    needsBlog: true,
    needsGroups: true,
  },
};

const ALL_PLATFORMS = [
  "Instagram",
  "Facebook",
  "Twitter / X",
  "WhatsApp",
  "Telegram",
  "YouTube",
  "Pinterest",
  "LinkedIn",
  "TikTok",
  "Other",
];

// ── Component ─────────────────────────────────────────────────────────────────

const FreeExtensionModal = ({ open, onClose, onSuccess }) => {
  const [step, setStep] = useState(1);
  const [plansInfo, setPlansInfo] = useState(null);
  const [loadingPlans, setLoadingPlans] = useState(false);

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [withLogo, setWithLogo] = useState(false);

  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [blogUrl, setBlogUrl] = useState("");
  const [yogaGroups, setYogaGroups] = useState("");
  const [proofFiles, setProofFiles] = useState([]);

  // ── NEW: Sharing validation state ─────────────────────────────────────────
  const [sharedAt, setSharedAt] = useState("");
  const [hashtagInput, setHashtagInput] = useState("");
  const [yogareferTagged, setYogareferTagged] = useState(false);
  const [isPublicConfirmed, setIsPublicConfirmed] = useState(false);
  // Validation feedback from server
  const [validationErrors, setValidationErrors] = useState([]);
  const [validationWarnings, setValidationWarnings] = useState([]);

  const [submitting, setSubmitting] = useState(false);

  // ── Reset on open ─────────────────────────────────────────────────────────
  useEffect(() => {
    if (!open) return;
    setStep(1);
    setSelectedPlan(null);
    setWithLogo(false);
    setSelectedPlatforms([]);
    setBlogUrl("");
    setYogaGroups("");
    setProofFiles([]);
    // Reset sharing fields
    setSharedAt("");
    setHashtagInput("");
    setYogareferTagged(false);
    setIsPublicConfirmed(false);
    setValidationErrors([]);
    setValidationWarnings([]);

    const fetchPlans = async () => {
      setLoadingPlans(true);
      try {
        const token = sessionStorage.getItem("token");
        const { data } = await axios.get(
          `${BASE_URL}/free-extension/plans-info`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        setPlansInfo(data.data);
      } catch {
        message.error("Failed to load plan info.");
      } finally {
        setLoadingPlans(false);
      }
    };
    fetchPlans();
  }, [open]);

  // ── Helpers ───────────────────────────────────────────────────────────────

  const planMeta = selectedPlan ? PLAN_META[selectedPlan] : null;
  const planData = plansInfo?.plans?.find((p) => p.plan === selectedPlan);

  const togglePlatform = (platform) => {
    setSelectedPlatforms((prev) =>
      prev.includes(platform)
        ? prev.filter((p) => p !== platform)
        : [...prev, platform],
    );
  };

  // Parse hashtag input into array
  const parsedHashtags = hashtagInput
    .split(/[\s,]+/)
    .filter(Boolean)
    .map((h) => (h.startsWith("#") ? h : `#${h}`));

  const canProceedStep1 = !!selectedPlan;

  const canSubmit = () => {
    if (!selectedPlan || !planMeta) return false;
    if (selectedPlatforms.length < planMeta.platformsRequired) return false;
    if (planMeta.needsBlog && !blogUrl.trim()) return false;
    if (planMeta.needsGroups && !yogaGroups.trim()) return false;
    if (proofFiles.length === 0) return false;
    // Sharing validation fields — all required
    if (!sharedAt) return false;
    if (parsedHashtags.length === 0) return false;
    if (!yogareferTagged) return false;
    if (!isPublicConfirmed) return false;
    return true;
  };

  // ── Submit ────────────────────────────────────────────────────────────────

  const handleSubmit = async () => {
    if (!canSubmit()) return;
    setSubmitting(true);
    setValidationErrors([]);
    setValidationWarnings([]);

    try {
      const token = sessionStorage.getItem("token");
      const formData = new FormData();

      // Existing fields
      formData.append("plan", selectedPlan);
      formData.append("withLogo", String(withLogo));
      formData.append("platforms", JSON.stringify(selectedPlatforms));
      if (blogUrl) formData.append("blogUrl", blogUrl);
      if (yogaGroups) {
        formData.append(
          "yogaGroups",
          JSON.stringify(
            yogaGroups
              .split("\n")
              .map((g) => g.trim())
              .filter(Boolean),
          ),
        );
      }
      proofFiles.forEach((f) =>
        formData.append("proofImages", f.originFileObj),
      );

      // ── NEW: Sharing validation fields ──────────────────────────────────
      formData.append("sharedAt", new Date(sharedAt).toISOString());
      formData.append("sharingHashtags", JSON.stringify(parsedHashtags));
      formData.append("yogareferTagged", String(yogareferTagged));
      formData.append("isPublicConfirmed", String(isPublicConfirmed));

      const { data } = await axios.post(
        `${BASE_URL}/free-extension/submit`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      // Show warnings even on success (e.g. #YogaWith[Name] not auto-verified)
   

     if (data.warnings?.length > 0) {
  setValidationWarnings(data.warnings);
  message.success("Request submitted! Please note the warnings below.");
  onSuccess?.();
  // Don't call onClose() — let user read warnings and close manually
} else {
  message.success(`Request submitted! You'll receive ${data.data.extensionDays} days on approval.`);
  onSuccess?.();
  onClose();
}
    } catch (err) {
      const errData = err.response?.data;
      // Show field-level validation errors inline instead of just a toast
      if (errData?.validationErrors?.length > 0) {
        setValidationErrors(errData.validationErrors);
        if (errData?.warnings?.length > 0)
          setValidationWarnings(errData.warnings);
      } else {
        const errMsg = errData?.error ?? "Submission failed. Please try again.";
        message.error(errMsg);
        setValidationErrors([errMsg]); // also show inline
      }
    } finally {
      setSubmitting(false);
    }
  };

  // ── Render ────────────────────────────────────────────────────────────────

  if (!open) return null;

  return (
    <AnimatePresence>
      {open && (
        <>
          {/* Backdrop */}
          <motion.div
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              zIndex: 1000,
            }}
          />

          {/* Modal */}
<motion.div
  initial={{ opacity: 0, scale: 0.88, x: "-50%", y: "calc(-50% + 24px)" }}
  animate={{ opacity: 1, scale: 1, x: "-50%", y: "-50%" }}
  exit={{ opacity: 0, scale: 0.88, x: "-50%", y: "calc(-50% + 24px)" }}
  transition={{ duration: 0.22, ease: "easeOut" }}
  style={{
    position: "fixed",
    top: "50%",
    left: "50%",
    zIndex: 1001,
    width: "calc(100vw - 24px)",
    maxWidth: 580,
    maxHeight: "90vh",
    overflowY: "auto",
    overflowX: "hidden",
    background: "#fff",
    borderRadius: 20,
    boxShadow: "0 24px 80px rgba(0,0,0,0.18)",
    padding: "18px 14px 18px",
    boxSizing: "border-box",
  }}
>
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
              }}
            >
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: 20,
                    fontWeight: 800,
                    color: "#1a1a2e",
                  }}
                >
                  Free Extension
                </h2>
                <p
                  style={{ margin: "4px 0 0", fontSize: 13, color: "#6b7280" }}
                >
                  Share yogarefer.com and get a free extension
                </p>
              </div>
              <button
                onClick={onClose}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: 22,
                  cursor: "pointer",
                  color: "#6b7280",
                }}
              >
                ×
              </button>
            </div>

            {/* Step indicator */}
            <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
              {["Choose Plan", "Submit Proof"].map((label, i) => (
                <div
                  key={i}
                  style={{
                    flex: 1,
                    textAlign: "center",
                    padding: "6px 0",
                    borderRadius: 8,
                    fontSize: 12,
                    fontWeight: 600,
                    background: step === i + 1 ? "#4f46e5" : "#f3f4f6",
                    color: step === i + 1 ? "#fff" : "#9ca3af",
                  }}
                >
                  {i + 1}. {label}
                </div>
              ))}
            </div>

            {/* ── STEP 1: Choose Plan ── */}
            {step === 1 && (
              <>
                {loadingPlans ? (
                  <div style={{ textAlign: "center", padding: "40px 0" }}>
                    <Spin size="large" />
                  </div>
                ) : (
                  <>
                    {plansInfo && (
                      <div
                        style={{
                          background: "#f0f9ff",
                          border: "1px solid #bae6fd",
                          borderRadius: 10,
                          padding: "10px 14px",
                          marginBottom: 16,
                          fontSize: 13,
                          color: "#0369a1",
                        }}
                      >
                        📊 You have <strong>{plansInfo.approvedCount}</strong>{" "}
                        approved image(s) → Tier{" "}
                        <strong>{plansInfo.tier.toUpperCase()}</strong>
                      </div>
                    )}

                   <div
                      style={{
                        background: "#faf5ff",
                        border: "1px solid #e9d5ff",
                        borderRadius: 10,
                        padding: "10px 14px",
                        marginBottom: 18,
                      }}
                    >
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          cursor: "pointer",
                          fontSize: 13,
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={withLogo}
                          onChange={(e) => setWithLogo(e.target.checked)}
                          style={{ width: 16, height: 16, flexShrink: 0 }}
                        />
                        <div>
                          <span style={{ fontWeight: 600, color: "#7c3aed", display: "block" }}>
                            Include logo watermark
                          </span>
                          <span style={{ fontSize: 11, color: "#9ca3af" }}>
                            (fewer days, but your logo shown on images)
                          </span>
                        </div>
                      </label>
                    </div>

                    <div style={{ display: "grid", gap: 12 }}>
                      {(plansInfo?.plans ?? []).map((p) => {
                        const meta = PLAN_META[p.plan];
                        const days = withLogo
                          ? p.withLogoDays
                          : p.mediaOnlyDays;
                        const isSelected = selectedPlan === p.plan;
                        return (
                          <div
                            key={p.plan}
                            onClick={() => setSelectedPlan(p.plan)}
                           style={{
                              border: `2px solid ${isSelected ? meta.color : meta.border}`,
                              borderRadius: 12,
                              padding: "12px 14px",
                              cursor: "pointer",
                              background: isSelected ? meta.bg : "#fff",
                              transition: "all 0.15s",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div
                                style={{
                                  fontWeight: 700,
                                  fontSize: 14,
                                  color: meta.color,
                                }}
                              >
                                {isSelected && (
                                  <CheckCircleFilled
                                    style={{ marginRight: 6 }}
                                  />
                                )}
                                {meta.label}
                              </div>
                             <div
                                style={{
                                  fontSize: 11,
                                  color: "#6b7280",
                                  marginTop: 3,
                                  lineHeight: 1.4,
                                }}
                              >
                                {meta.instruction}
                              </div>
                            </div>
                          <div style={{ textAlign: "right", flexShrink: 0 }}>
                              <div
                                style={{
                                  fontSize: 20,
                                  fontWeight: 800,
                                  color: meta.color,
                                }}
                              >
                                +{days}d
                              </div>
                              <div style={{ fontSize: 10, color: "#9ca3af" }}>
                                {withLogo ? "with logo" : "media only"}
                              </div>
                              <div style={{ fontSize: 10, color: "#d1d5db" }}>
                                / {withLogo ? p.mediaOnlyDays : p.withLogoDays}d{" "}
                                {withLogo ? "no logo" : "with logo"}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <button
                      disabled={!canProceedStep1}
                      onClick={() => setStep(2)}
                      style={{
                        marginTop: 20,
                        width: "100%",
                        padding: "13px 0",
                        borderRadius: 12,
                        border: "none",
                        cursor: canProceedStep1 ? "pointer" : "not-allowed",
                        background: canProceedStep1 ? "#4f46e5" : "#e5e7eb",
                        color: canProceedStep1 ? "#fff" : "#9ca3af",
                        fontWeight: 700,
                        fontSize: 15,
                      }}
                    >
                      Continue →
                    </button>
                  </>
                )}
              </>
            )}

            {/* ── STEP 2: Submit Proof ── */}
            {step === 2 && planMeta && (
              <>
                {/* Selected plan summary */}
                <div
                  style={{
                    background: planMeta.bg,
                    border: `1px solid ${planMeta.border}`,
                    borderRadius: 10,
                    padding: "10px 14px",
                    marginBottom: 18,
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 12,
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 700, color: planMeta.color }}>
                      {planMeta.label}
                    </div>
                    <div style={{ fontSize: 12, color: "#6b7280" }}>
                      {planMeta.instruction}
                    </div>
                  </div>
                  <div style={{ textAlign: "right", minWidth: 0 }}>
                    <div
                      style={{
                        fontWeight: 800,
                        fontSize: 18,
                        color: planMeta.color,
                      }}
                    >
                      +
                      {withLogo
                        ? planData?.withLogoDays
                        : planData?.mediaOnlyDays}
                      d
                    </div>
                    <button
                      onClick={() => setStep(1)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#6b7280",
                        fontSize: 11,
                        cursor: "pointer",
                      }}
                    >
                      Change
                    </button>
                  </div>
                </div>

                {/* Platform selection */}
                <div style={{ marginBottom: 18 }}>
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: 13,
                      marginBottom: 8,
                      color: "#374151",
                    }}
                  >
                    ✅ Select platforms you shared on
                    <span
                      style={{
                        fontWeight: 400,
                        color: "#9ca3af",
                        marginLeft: 4,
                      }}
                    >
                      (need {planMeta.platformsRequired}, selected{" "}
                      {selectedPlatforms.length})
                    </span>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {ALL_PLATFORMS.map((platform) => {
                      const selected = selectedPlatforms.includes(platform);
                      return (
                        <button
                          key={platform}
                          onClick={() => togglePlatform(platform)}
                          style={{
                            padding: "6px 12px",
                            borderRadius: 20,
                            fontSize: 12,
                            border: `1.5px solid ${selected ? planMeta.color : "#d1d5db"}`,
                            background: selected ? planMeta.bg : "#fff",
                            color: selected ? planMeta.color : "#374151",
                            cursor: "pointer",
                            fontWeight: selected ? 700 : 400,
                          }}
                        >
                          {selected && "✓ "}
                          {platform}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Premium extras */}
                {planMeta.needsBlog && (
                  <div style={{ marginBottom: 14 }}>
                    <label
                      style={{
                        display: "block",
                        fontWeight: 600,
                        fontSize: 13,
                        marginBottom: 6,
                        color: "#374151",
                      }}
                    >
                      📝 Blog / Review URL{" "}
                      <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <input
                      type="url"
                      placeholder="https://yourblog.com/yogarefer-review"
                      value={blogUrl}
                      onChange={(e) => setBlogUrl(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        borderRadius: 8,
                        border: "1.5px solid #d1d5db",
                        fontSize: 13,
                        boxSizing: "border-box",
                        outline: "none",
                      }}
                    />
                  </div>
                )}

                {planMeta.needsGroups && (
                  <div style={{ marginBottom: 14 }}>
                    <label
                      style={{
                        display: "block",
                        fontWeight: 600,
                        fontSize: 13,
                        marginBottom: 6,
                        color: "#374151",
                      }}
                    >
                      🧘 Yoga Groups (one per line){" "}
                      <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <textarea
                      placeholder="Yoga lovers - Facebook Group&#10;Daily Yoga - Telegram&#10;..."
                      value={yogaGroups}
                      onChange={(e) => setYogaGroups(e.target.value)}
                      rows={3}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        borderRadius: 8,
                        border: "1.5px solid #d1d5db",
                        fontSize: 13,
                        boxSizing: "border-box",
                        resize: "vertical",
                        outline: "none",
                      }}
                    />
                  </div>
                )}

                {/* ── NEW: When did you share? ───────────────────────────────── */}
                <div style={{ marginBottom: 14 }}>
                  <label
                    style={{
                      display: "block",
                      fontWeight: 600,
                      fontSize: 13,
                      marginBottom: 6,
                      color: "#374151",
                    }}
                  >
                    🕐 When did you share?{" "}
                    <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    type="datetime-local"
                    value={sharedAt}
                    max={new Date().toISOString().slice(0, 16)} // can't be future
                    onChange={(e) => setSharedAt(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 8,
                      border: "1.5px solid #d1d5db",
                      fontSize: 13,
                      boxSizing: "border-box",
                      outline: "none",
                    }}
                  />
                  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 3 }}>
                    Proof must be submitted within 48 hours of this time.
                  </div>
                </div>

                {/* ── NEW: Hashtags used ────────────────────────────────────── */}
                <div style={{ marginBottom: 14 }}>
                  <label
                    style={{
                      display: "block",
                      fontWeight: 600,
                      fontSize: 13,
                      marginBottom: 6,
                      color: "#374151",
                    }}
                  >
                    # Hashtags used <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="#YogaRefer #YogaWithYourName"
                    value={hashtagInput}
                    onChange={(e) => setHashtagInput(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 8,
                      border: "1.5px solid #d1d5db",
                      fontSize: 13,
                      boxSizing: "border-box",
                      outline: "none",
                    }}
                  />
                  {/* Live preview of parsed hashtags */}
                  {parsedHashtags.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 4,
                        marginTop: 6,
                      }}
                    >
                      {parsedHashtags.map((h, i) => (
                        <span
                          key={i}
                          style={{
                            background: "#eff6ff",
                            color: "#3b82f6",
                            padding: "2px 8px",
                            borderRadius: 12,
                            fontSize: 11,
                            fontWeight: 600,
                          }}
                        >
                          {h}
                        </span>
                      ))}
                    </div>
                  )}
                  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
                    Must include <strong>#YogaRefer</strong> and{" "}
                    <strong>#YogaWith[YourName]</strong>. Separate by space or
                    comma.
                  </div>
                </div>

                {/* ── NEW: Checkboxes ───────────────────────────────────────── */}
                <div
                  style={{
                    background: "#f9fafb",
                    border: "1px solid #e5e7eb",
                    borderRadius: 10,
                    padding: "12px 14px",
                    marginBottom: 18,
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      cursor: "pointer",
                      fontSize: 13,
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={yogareferTagged}
                      onChange={(e) => setYogareferTagged(e.target.checked)}
                      style={{ width: 16, height: 16, accentColor: "#4f46e5" }}
                    />
                    <span style={{ color: "#374151" }}>
                      I tagged <strong>@yogarefer</strong> in my post
                      <span style={{ color: "#ef4444" }}> *</span>
                    </span>
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      cursor: "pointer",
                      fontSize: 13,
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isPublicConfirmed}
                      onChange={(e) => setIsPublicConfirmed(e.target.checked)}
                      style={{ width: 16, height: 16, accentColor: "#4f46e5" }}
                    />
                    <span style={{ color: "#374151" }}>
                      I confirm my post is set to <strong>Public</strong>{" "}
                      visibility
                      <span style={{ color: "#ef4444" }}> *</span>
                    </span>
                  </label>
                </div>

                {/* Proof screenshot upload */}
                <div style={{ marginBottom: 16 }}>
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: 13,
                      marginBottom: 8,
                      color: "#374151",
                    }}
                  >
                    📸 Upload Proof Screenshots{" "}
                    <span style={{ color: "#ef4444" }}>*</span>
                  </div>
                  <Upload
                    listType="picture-card"
                    fileList={proofFiles}
                    onChange={({ fileList }) => setProofFiles(fileList)}
                    beforeUpload={() => false}
                    accept="image/*"
                    multiple
                    maxCount={10}
                  >
                    {proofFiles.length < 10 && (
                      <div>
                        <UploadOutlined />
                        <div style={{ fontSize: 12, marginTop: 4 }}>Upload</div>
                      </div>
                    )}
                  </Upload>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
                    Screenshot must show hashtags, @yogarefer tag, and public
                    post. Max 10.
                  </div>
                </div>

                {/* ── NEW: Server validation errors ─────────────────────────── */}
                {validationErrors.length > 0 && (
                  <div
                    style={{
                      background: "#fef2f2",
                      border: "1px solid #fca5a5",
                      borderRadius: 8,
                      padding: "10px 14px",
                      marginBottom: 12,
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: 13,
                        color: "#dc2626",
                        marginBottom: 6,
                      }}
                    >
                      ❌ Please fix the following:
                    </div>
                    {validationErrors.map((e, i) => (
                      <div
                        key={i}
                        style={{
                          fontSize: 12,
                          color: "#dc2626",
                          marginBottom: 3,
                        }}
                      >
                        • {e}
                      </div>
                    ))}
                  </div>
                )}

                {/* ── NEW: Server warnings (non-blocking) ───────────────────── */}
                {validationWarnings.length > 0 && (
                  <div
                    style={{
                      background: "#fffbeb",
                      border: "1px solid #fcd34d",
                      borderRadius: 8,
                      padding: "10px 14px",
                      marginBottom: 12,
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: 13,
                        color: "#92400e",
                        marginBottom: 6,
                      }}
                    >
                      <WarningOutlined style={{ marginRight: 6 }} />
                      Note:
                    </div>
                    {validationWarnings.map((w, i) => (
                      <div
                        key={i}
                        style={{
                          fontSize: 12,
                          color: "#92400e",
                          marginBottom: 3,
                        }}
                      >
                        • {w}
                      </div>
                    ))}
                  </div>
                )}

                {/* Reminder box */}
                <div
                  style={{
                    background: "#fffbeb",
                    border: "1px solid #fcd34d",
                    borderRadius: 8,
                    padding: "10px 12px",
                    marginBottom: 18,
                    fontSize: 12,
                    color: "#92400e",
                  }}
                >
                  <ClockCircleOutlined style={{ marginRight: 6 }} />
                  Share must be <strong>public</strong>, include{" "}
                  <strong>#YogaRefer</strong> and{" "}
                  <strong>#YogaWith[YourName]</strong>, within{" "}
                  <strong>48 hours</strong> of submission.
                </div>

                {/* Action buttons */}
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <button
                    onClick={() => setStep(1)}
                    style={{
                      flex: "1 1 120px",
                      padding: "12px 0",
                      borderRadius: 12,
                      border: "1.5px solid #d1d5db",
                      background: "#fff",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: 14,
                      color: "#374151",
                    }}
                  >
                    ← Back
                  </button>
                  <button
                    disabled={!canSubmit() || submitting}
                    onClick={handleSubmit}
                    style={{
                      flex: "1 1 220px",
                      padding: "12px 0",
                      borderRadius: 12,
                      border: "none",
                      cursor:
                        canSubmit() && !submitting ? "pointer" : "not-allowed",
                      background:
                        canSubmit() && !submitting ? "#4f46e5" : "#e5e7eb",
                      color: canSubmit() && !submitting ? "#fff" : "#9ca3af",
                      fontWeight: 700,
                      fontSize: 15,
                    }}
                  >
                    {submitting ? <Spin size="small" /> : "Submit Request 🚀"}
                  </button>
                </div>
              </>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default FreeExtensionModal;
